import { render, staticRenderFns } from "./WorkBaseTabs.vue?vue&type=template&id=5d83541a&scoped=true"
import script from "./WorkBaseTabs.vue?vue&type=script&lang=js"
export * from "./WorkBaseTabs.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseTabs.vue?vue&type=style&index=0&id=5d83541a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83541a",
  null
  
)

export default component.exports